import { ComponentProps, ReactNode } from 'react';
import { ValueOf, SizingProps, SpacingProps, StylingTransientProps, Theme } from '@redsift/design-system';

/**
 * Component variant.
 */
export const ToastVariant = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
  loading: 'loading',
} as const;
export type ToastVariant = ValueOf<typeof ToastVariant>;

export const ToastPlacement = {
  'top-right': 'top-right',
  'top-center': 'top-center',
  'top-left': 'top-left',
  'bottom-right': 'bottom-right',
  'bottom-center': 'bottom-center',
  'bottom-left': 'bottom-left',
} as const;
export type ToastPlacement = ValueOf<typeof ToastPlacement>;

/**
 * Component props.
 */
export interface ToastProps extends Omit<ComponentProps<'div'>, 'id' | 'style'>, SpacingProps, SizingProps {
  /**
   * Whether the component has a close button or not, or the node to put in its
   * place. A Design System Button or IconButton — a `styled()` one included —
   * takes the variant colour and dismisses the Toast; any other node renders as
   * given.
   * @default true
   */
  closeButton?: boolean | ReactNode;
  /** Title. */
  title?: string;
  /** Theme. */
  theme?: Theme;
  /**
   * Variant
   * @default 'info'
   */
  variant?: ToastVariant;
}

export interface StyledToastProps extends ComponentProps<'div'>, StylingTransientProps {
  $hasTitle: boolean;
  $variant: ToastProps['variant'];
  $theme: Theme;
}
